import React from 'react';
import { INIT_STATE } from './reducer';

export const ModularListingContext = React.createContext({
  modularListingState: INIT_STATE,
  reducerDispatch: {},
});
